export const ASC = 'ASC' as const;
export const DESC = 'DESC' as const;
export const NONE = 'NONE' as const;

export type SortOrder = typeof ASC | typeof DESC | typeof NONE;
